<template>
  <custom-dialog width="75%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="padding-top: 0">
      <div class="search-hd">
        <el-form :inline="true">
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('base_select_location_dialog.xiang_mu_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <el-input style="width: 220px" :placeholder="$t('base_select_location_dialog.gong_si_ming_cheng')" v-model="formSearch.company"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <custom-table type="checkbox" :tableCode="'organ_select_location'" v-model="tableSelect" @column="setColumn" :data="tableList" @filter="filterChange" @sort="sortChange"></custom-table>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onBind">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  props: {
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableList: [],
      totalRows: 0,
      tableSelect: [],

      formSearch: {
        search: '',
        company: '',
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 0,
        pageSize: 10,
        pageNum: 1,
      },
    };
  },
  mounted() {
    this.getLocationPage();
  },
  methods: {
    // 可选项目
    getLocationPage: function () {
      this.formSearch.bizId = this.organ.bizId;
      this.formSearch.bizType = this.organ.bizType;
      this.formSearch.parentId = this.organ.orgId;
      this.$getJSON(apis.deviceLocationPage, this.formSearch).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLocationPage();
    },
    // 关联
    onBind: function () {
      const params = this.tableSelect.map((t) => ({
        orgId: this.organ.orgId,
        bizId: this.organ.bizId,
        bizType: this.organ.bizType,
        toBizId: t.locationId,
        toBizType: 4,
      }));
      this.$postJSON(apis.organDeviceBindAutoAdd, params).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
</style>
